/*
 * @Author: liujunhong
 * @Date: 2023/7/5
 * @Desc: 表单配置
 */


import { REGEX_PHONE, REGEX_SMS_CODE } from '@/constants/reg';
import { StepFirstProps } from '@/pages/changeBindApp/index';
import { SEND_SMS_SOURCE_TYPE, SEND_VC_TYPE } from '@/constants';


export const getFirstConditions = (props: StepFirstProps) => {
  const {authedPhone, setErrorTips, setUpdateLogin, loginInfo} = props;
  return [{
    label: '原绑定APP',
    type: 'TEXT',
    key: 'authedPhone',
    render: () => <div style={{color: '#c00', fontWeight: 700}}>{authedPhone}</div>,
  }, {
    label: '短信验证码',
    type: 'SEND_SMS',
    key: 'verifyCode',
    name: 'verifyCode',
    rules: [
      {
        required: true,
        message: '请输入短信验证码',
      },
      {
        pattern: REGEX_SMS_CODE,
        message: '您输入的验证码不正确',
      },

    ],
    options: {
      sourceType: SEND_SMS_SOURCE_TYPE.VERIFY_PHONE,
      inputId: 'input_change_app_first',
      btnId: 'btn_change_app_first',
      onError: (res: any) => {
        setErrorTips(res.message);
      },
    },
  }, {
    type: 'BUTTON',
    key: 'btn_change_app_first',
    options: {
      text: '下一步',
      id: 'btn_change_app_first',
      onClick: () => {
        if (!loginInfo?.isLogin) {
          setUpdateLogin?.({isLogin: false, visibleLogin: true});
        }
      },
    },
  }];
};

interface StepSecond extends StepFirstProps {
  mobile: number;
}

export const getSecondConditions = (props: StepSecond) => {
  const {setErrorTips, mobile} = props;
  return [{
    label: '绑定新APP',
    type: 'INPUT',
    key: 'phone',
    name: 'phone',
    rules: [
      {
        required: true,
        message: <span id="text_tel_change_phone">请输入手机号</span>,
      },
      {
        pattern: REGEX_PHONE,
        message: <span id="text_tel_change_phone">手机号格式不正确，请您重新输入</span>,
      },
    ],
    options: {
      maxLength: 11,
    },
  }, {
    label: '短信验证码',
    type: 'SEND_SMS',
    name: 'verifyCode',
    key: 'verifyCode',
    rules: [
      {
        required: true,
        message: '请输入短信验证码',
      },
      {
        pattern: REGEX_SMS_CODE,
        message: '您输入的验证码不正确',
      },

    ],
    options: {
      sourceType: SEND_SMS_SOURCE_TYPE.CHANGE_PHONE,
      inputId: 'input_change_app_second',
      btnId: 'btn_change_app_second',
      phoneNumber: mobile,
      disabled: !REGEX_PHONE.test(String(mobile)),
      sendUserType: SEND_VC_TYPE.PHONE,
      onError: (res: any) => {
        setErrorTips(res.message);
      },
    },
  }, {
    type: 'BUTTON',
    key: 'btn_change_app_second',
    options: {
      text: '确认',
      id: 'btn_change_app_second',

    },
  }];
};